import styled, { css } from 'styled-components';

import Box from '../../Layout/Box';
import { cssDeclaration, normalizeColor } from '../../Utils/';

const thumbStyles = css`
  -webkit-appearance: none;
  border-radius: 100%;
  border: none;
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  ${({theme: { themeTwo }}) => {
    if (themeTwo.form.slider) {
      const thumbHeight = themeTwo.form.slider.thumb.height;

      return css`
        width: ${thumbHeight}px;
        height: ${thumbHeight}px;
        /* background-color */ ${cssDeclaration(themeTwo, 'background-color', themeTwo.form.slider.thumb.color.default)}
      `;
    }
  }};

`;

export const trackStyles = css`
  -webkit-appearance: none;
  border: none;
  ${({theme: { themeTwo }}) => themeTwo.form.slider && css`
    height: ${themeTwo.form.slider.track.thickness}px;
    ${cssDeclaration(themeTwo, 'border-radius', themeTwo.form.slider.track.borderRadius)}
  `}
`;

export const Slider = styled.input`
    -webkit-appearance: none;
    margin-top: 3rem;
    width: 100%;
    cursor: pointer;
    ${trackStyles}

    &:focus {
      ${({theme: { themeTwo }}) => themeTwo.form.slider && cssDeclaration(themeTwo, 'outline', themeTwo.form.slider.outline)}

      @-moz-document url-prefix() {
        outline-offset: 0;
      }
    }

    &::-webkit-slider-thumb {
      ${thumbStyles}
    }

    &::-webkit-slider-runnable-track {
      ${trackStyles}

    }

    &::-moz-range-thumb {
      ${thumbStyles}
      top: auto;
      transform: none;
    }

    &::-moz-range-track {
      ${trackStyles}
    }

    &:disabled {
      background: none;
      ${({ theme: { themeTwo } }) => css`
        &::-webkit-slider-thumb {
          background:
            ${normalizeColor(themeTwo, themeTwo.form.slider && themeTwo.form.slider.thumb.color.disabled)} !important;
        }

        &::-moz-range-thumb {
          background:
            ${normalizeColor(themeTwo, themeTwo.form.slider && themeTwo.form.slider.thumb.color.disabled)} !important;
        }
      `}
    }
  }
`;

export const SliderUnitLabels = styled(Box)<{disabled?: boolean}>`
  > div {
  ${({disabled, theme: { themeTwo }}) => {
    if (disabled) {
      return css`
        /* color */ ${themeTwo.form.slider && cssDeclaration(themeTwo, 'color', themeTwo.form.slider.unitLabels.color.disabled)};
      `;
    } else {
      return css`
        /* color */ ${themeTwo.form.slider && cssDeclaration(themeTwo, 'color', themeTwo.form.slider.unitLabels.color.default)};
      `;
    }
  }}

  ${({theme: {themeTwo}}) => {
    const { slider } = themeTwo.form;

    return css`
      ${slider.unitLabels.margin && cssDeclaration(themeTwo, 'margin', { top: slider.unitLabels.margin.top })};
    `;
  }}
`;
